import React from "react";

const LoaderAuth = () => {
  return (

    <>
    <div class="text-center" style={{ width: "100%", height:'100vh',display:'flex',justifyContent:'center',alignItems:'center',justifyContent:'center' }}>
      <div class="spinner-border" role="status">
        <span class="sr-only" style={{color:"var(--couleur-principale)"}}></span>
      </div>
        <span>Chargement ...</span>
    </div>
    </>
  );
};

export default LoaderAuth;
